import React from 'react';
import { connect } from 'react-redux';

import { TransitionGroup, CSSTransition } from 'react-transition-group';

import Blank from '../templates/blank';
import Home from '../templates/Home';
import Showcase from '../templates/showcase';
import Project from '../templates/project';
import Info from '../templates/information';
// import ThreeD from '../templates/ThreeD';
// import Search from '../templates/Search';

import { Route, Switch, withRouter } from 'react-router-dom';

function mapStateToProps(state) {
  return {
    currentPath: state.UI.currentPath,
  };
}

class Loader extends React.PureComponent {
  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }

  render() {
    console.log('Loader render', this.props.location.pathname);
    return (
      <div className="Site-body">
        <div className="Site-project">
          <TransitionGroup>
            <CSSTransition
              key={this.props.location.key}
              classNames="fade"
              timeout={800}
            >
              <div className="Transition">
                <Switch location={this.props.location}>
                  <Route path="/" exact component={Blank} />
                  <Route path="/projects" exact component={Showcase} />
                  <Route path="/information" exact component={Info} />
                  <Route path="/:pageSlug?" component={Project} />
                </Switch>
              </div>
            </CSSTransition>
          </TransitionGroup>
        </div>

        {this.props.location.pathname === '/' && <Home />}
        {this.props.location.pathname !== '/' &&
          this.props.location.pathname !== '/information' &&
          this.props.location.pathname !== '/projects' && <Showcase />}

        {/* <Archive/> */}
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps, null)(Loader));



// WEBPACK FOOTER //
// ./src/js/components/Loader.jsx